export default __webpack_public_path__ + "b259935a743e7ad0f44689c6f75ae740.svg";